// extracted by mini-css-extract-plugin
module.exports = {"TitleNameSurname":"Titles_TitleNameSurname__18-nb","TitleWorkPlace":"Titles_TitleWorkPlace__3Ce7i"};